import script from "./DrawerShift.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawerShift.vue?vue&type=script&setup=true&lang=js"

import "./DrawerShift.vue?vue&type=style&index=0&id=c3cf86de&lang=css"

const __exports__ = script;

export default __exports__